// caiet UC31-02 / NFR §7.4: the client secret is generated in the browser and
// only its SHA-256 hash is sent to the server. The plaintext is shown to the
// Administrator exactly once and never leaves the browser.
//
// The hash is taken over the base64url plaintext string (the value the user
// copies), matching auth-service's verifySecret which hashes the submitted
// secret string at the /oauth2/token (UC15) exchange on public-api.

function base64url(bytes: Uint8Array): string {
  let binary = '';
  for (const byte of bytes) {
    binary += String.fromCharCode(byte);
  }
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export async function generateClientSecret(): Promise<{ plaintext: string; sha256Hex: string }> {
  const bytes = crypto.getRandomValues(new Uint8Array(32));
  const plaintext = base64url(bytes);
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(plaintext));
  const sha256Hex = Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
  return { plaintext, sha256Hex };
}
